import React, { useContext, useState } from 'react';
import T from '@prisjakt/ui-translate';
import Button from '@prisjakt/ui-button';
import FilterIcon from 'mdi-react/FilterVariantIcon';
import ChevronUpIcon from 'mdi-react/ChevronUpIcon';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import { defaultHiddenListOptions, getNumberOfActiveFilters } from '../utils';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { getAllFilters } from '../utils/filters-config';
import { AppContext } from '@prisjakt/ui-app-context';

const FilterToggleButton: React.FC<IFilterOptionProps> = props => {
  const { onToggle } = props;
  const { filters } = useContext(PriceListFilterContext);
  const { t, market } = useContext(AppContext);
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const [hiddenListOptions] = useState<string[]>(
    defaultHiddenListOptions(market)
  );
  const filtersConfig = getAllFilters(t, filters, hiddenListOptions);

  const nbrOfActiveFilters = getNumberOfActiveFilters(filters, filtersConfig);

  const onClick = () => {
    const newVal = !showFilters;
    setShowFilters(newVal);
    onToggle(newVal);
  };

  return (
    <Button
      color="primary"
      variant="outlined"
      size="small"
      icon={<FilterIcon />}
      onClick={onClick}
      title="List options"
    >
      <T domain="product" product="price-filter.button-title">
        price-filter.button-title
      </T>
      &nbsp;{nbrOfActiveFilters > 0 && `(${nbrOfActiveFilters})`}
      {showFilters ? <ChevronUpIcon /> : <ChevronDownIcon />}
    </Button>
  );
};

interface IFilterOptionProps {
  onToggle: (val: boolean) => void;
}

export default FilterToggleButton;
